export const CREATE_PAGE = 'CREATE_PAGE';
export const GET_PAGES = 'GET_PAGES';
export const GET_PAGE = 'GET_PAGE';
export const DELETE_PAGE = 'DELETE_PAGE';
export const CREATE_LINK = 'CREATE_LINK';
export const DELETE_LINK = 'DELETE_LINK';
export const UPDATE_DND_LIST = 'UPDATE_DND_LIST';